import { getLoginToken } from '../../pages/lib';

export const connectPostSSE = ({
  url = '/api/sse2',
  body = {},
  onEvent = (event: any) => {
    console.log(event);
  },
} = {}) => {
  const controller = new AbortController();
  const { signal } = controller;

  let closed = false;

  async function start() {
    const ticket = getLoginToken();
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        ticket,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      signal,
    });

    if (!res.ok) {
      throw new Error(`Network response was not ok: ${res.status}`);
    }

    if (!res.body) {
      throw new Error(`Error: ${res.status}`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    try {
      while (true) {
        if (closed) break;
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        // 处理可能包含多个完整事件块的 buffer（事件块以 "\n\n" 或 "\r\n\r\n" 结尾）
        let sepIdx;
        while (
          (sepIdx = buffer.indexOf('\n\n')) !== -1 ||
          (sepIdx = buffer.indexOf('\r\n\r\n')) !== -1
        ) {
          // 优先 \r\n\r\n 的情况已经被兼容上面的判断
          const rawEvent = buffer.slice(0, sepIdx);
          buffer = buffer.slice(sepIdx + (buffer[sepIdx] === '\r' ? 4 : 2));
          parseAndEmit(rawEvent);
        }
      }

      // 流结束时，若 buffer 中仍有未结束的数据，尝试解析一次
      if (buffer.trim()) parseAndEmit(buffer);
    } catch (err) {
      if (!closed) {
        // 网络或解析错误
        console.error('SSE stream error', err);
        onEvent({ type: 'error', data: err });
      }
    } finally {
      closed = true;
      try {
        reader.releaseLock();
      } catch (e) {}
      onEvent({ type: 'close' });
    }
  }

  function parseAndEmit(raw: any) {
    // 按行拆分（支持 \n 和 \r\n）
    const lines = raw.split(/\r?\n/);
    let eventType = 'message';
    const dataLines = [];

    for (const line of lines) {
      if (line.startsWith('event:')) {
        eventType = line.slice(6).trim();
      } else if (line.startsWith('data:')) {
        dataLines.push(line.slice(5)); // 不 trim 左侧空格，保留协议允许的空格
      } else if (line.startsWith(':')) {
        // 注释行，忽略
      } else if (line.trim() === '') {
        // 空行，应已被分割，不一定会触发
      }
      // 忽略其他未识别字段（id:, retry: 等如果需要，可以扩展）
    }

    const data = dataLines.join('\n').trim();
    if (!data) return;
    try {
      const jsonData = JSON.parse(data);
      onEvent({ type: eventType || 'message', data: jsonData });
    } catch (e) {
      onEvent({ type: eventType || 'message', data });
    }
  }

  // 启动连接（异步）
  start().catch((err) => {
    if (!closed) {
      console.error('Failed to open SSE proxy stream', err);
      onEvent({ type: 'error', data: err });
    }
  });

  return {
    close: () => {
      closed = true;
      controller.abort();
    },
  };
};
